import { render, staticRenderFns } from "./Suspendedwindow.vue?vue&type=template&id=4aedd643&scoped=true&"
import script from "./Suspendedwindow.vue?vue&type=script&lang=js&"
export * from "./Suspendedwindow.vue?vue&type=script&lang=js&"
import style0 from "./Suspendedwindow.vue?vue&type=style&index=0&id=4aedd643&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aedd643",
  null
  
)

export default component.exports